import { __assign } from "tslib";
import React, { useContext, useEffect } from 'react';
import classnames from 'classnames';
import noop from '../../../../utils/noop';
import { DropdownStateContext } from '../../../DropdownStateManager';
import StandardMenuOption from '../StandardMenuOption';
import { useMenuItemHotkeys } from '../hooks';
import { itemWithOnSelect } from '../utils';
import s from './StandardMenuGroup.scss';
var StandardMenuGroup = function (_a) {
    var id = _a.id, _b = _a.item, groupClassName = _b.className, groupDisabled = _b.disabled, items = _b.items, className = _a.className, itemClassName = _a.itemClassName, hideCheckIcon = _a.hideCheckIcon, withHoverEffect = _a.withHoverEffect, _c = _a.onPassGroupStart, onPassGroupStart = _c === void 0 ? noop : _c, _d = _a.onPassGroupEnd, onPassGroupEnd = _d === void 0 ? noop : _d, focused = _a.focused, startIndexOnFocus = _a.startIndexOnFocus, onSelect = _a.onSelect, onSearch = _a.onSearch, onPressHome = _a.onPressHome, onPressEnd = _a.onPressEnd;
    var _e = useContext(DropdownStateContext), isOpen = _e.isOpen, firstKeyInteraction = _e.firstKeyInteraction;
    var _f = useMenuItemHotkeys(items.length, {
        onPassStart: function () {
            onPassGroupStart();
            setCurrentIndex(null);
        },
        onPassEnd: function () {
            onPassGroupEnd();
            setCurrentIndex(null);
        },
        onPressHome: onPressHome,
        onPressEnd: onPressEnd,
        onSearch: onSearch,
    }), handleKeyboardEvents = _f.handleKeyboardEvents, currentIndex = _f.currentIndex, setCurrentIndex = _f.setCurrentIndex;
    useEffect(function () {
        if (isOpen && focused) {
            setCurrentIndex(startIndexOnFocus !== null && startIndexOnFocus !== void 0 ? startIndexOnFocus : 0);
        }
        else {
            setCurrentIndex(null);
        }
    }, [
        isOpen,
        firstKeyInteraction,
        setCurrentIndex,
        startIndexOnFocus,
        focused,
    ]);
    return (React.createElement("div", { className: classnames(s['menu-group'], groupClassName, className), tabIndex: 0, onKeyDown: function (e) {
            if (focused) {
                handleKeyboardEvents(e);
                e.stopPropagation();
            }
        }, role: "group" }, items.map(function (item, idx) { return (React.createElement(StandardMenuOption, { id: id + "-option-" + idx, item: __assign(__assign({}, itemWithOnSelect(item, onSelect)), { disabled: groupDisabled || item.disabled }), className: itemClassName, hideCheckIcon: hideCheckIcon, withHoverEffect: withHoverEffect, focused: idx === currentIndex, key: "item_" + item.value + "_" + idx })); })));
};
StandardMenuGroup.displayName = 'StandardMenuGroup';
export default StandardMenuGroup;
//# sourceMappingURL=StandardMenuGroup.js.map